export default __webpack_public_path__ + "static/media/daypart.ae1a14ea.svg";